// extracted by mini-css-extract-plugin
export default {"label":"PasswordInput_label__0ZBp4","input":"PasswordInput_input__HGSSo","iconContainer":"PasswordInput_iconContainer__cH8D3"};